import type { CommunitiesResponse, Community } from "../fetchWebcastCommunities/fetchWebcastCommunities"

const getWebcastPrimaryCommunity = (communities: CommunitiesResponse): Community | null => {
    let primaryCommunity = null

    communities.communities.some((community: Community) => {
        if (community.childCount > 0) {
            return community.children.some((childCommunity: Community) => {
                if (childCommunity.enabled === true && childCommunity.primary === true) {
                    primaryCommunity = {
                        ...community,
                        children: [{
                            ...childCommunity
                        }]
                    }
                    return true
                }
                return false
            })
        }
        return false
    })

    return primaryCommunity

}

export default getWebcastPrimaryCommunity